import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const TeamSettingsViewTopBar = memo(() => {
	return <BaseTopBar showAIButton={false} />
})
TeamSettingsViewTopBar.displayName = "TeamSettingsViewTopBar"
